import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M12.47 19.26h.06a3.88 3.88 0 0 0 3.87-3.87V3.88A3.88 3.88 0 0 0 12.53 0h-.06A3.88 3.88 0 0 0 8.6 3.88v11.5a3.88 3.88 0 0 0 3.87 3.87M19 15.1v-4.62h-.92v4.62a5.45 5.45 0 0 1-5.44 5.44h-.1A5.45 5.45 0 0 1 7.1 15.1v-4.62h-.94v4.62a6.36 6.36 0 0 0 5.94 6.34v2.65H7v.9h11.1v-.92H13v-2.65a6.36 6.36 0 0 0 6-6.34" />
    </g>
  </svg>
);
